"use strict";
// reference: https://developers.braintreepayments.com/guides/paypal/client-side/javascript/v3
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var app_1 = require("../app");
var localization_1 = require("../localization");
var useContext = react_1.default.useContext, useEffect = react_1.default.useEffect;
var paypalButtonContainerId = 'paypal-express-checkout-container';
exports.default = (function (_a) {
    var setSubmitting = _a.setSubmitting;
    var context = useContext(app_1.CheckoutContext);
    var _b = __read((0, react_1.useState)(false), 2), isButtonRendered = _b[0], setButtonRendered = _b[1];
    var containerRef = (0, react_1.useRef)(null);
    if (!context)
        return null;
    var paypalCheckout = context.paypalCheckout, setPaymentInfo = context.setPaymentInfo, setPaymentMethod = context.setPaymentMethod, setPaymentValid = context.setPaymentValid, country = context.country, setShippingAddress = context.setShippingAddress, dataLayerPushEvent = context.dataLayerPushEvent, email = context.email, isUsingPaypalExpressCheckout = context.isUsingPaypalExpressCheckout, setUsingPaypalExpressCheckout = context.setUsingPaypalExpressCheckout;
    var config = localization_1.LocaleConfig[country];
    var history = (0, react_router_dom_1.useHistory)();
    useEffect(function () {
        if (containerRef.current)
            paypalEffect();
    }, [!!paypalCheckout, containerRef.current]);
    useEffect(function () {
        if (isUsingPaypalExpressCheckout) {
            history.push('/payment');
            setUsingPaypalExpressCheckout(false);
        }
    }, [isUsingPaypalExpressCheckout]);
    var handlePaypalData = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var pd, addr_1, fullState;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    setSubmitting(true);
                    setPaymentMethod('paypal');
                    setPaymentInfo({ cardType: 'paypal', email: payload.details.email, token: payload.nonce });
                    setPaymentValid(true);
                    dataLayerPushEvent('checkout__paypalExpressCheckoutApproved', {
                        shippingAddressPresent: !!payload.details.shippingAddress,
                        paypalCountry: (_b = (_a = payload.details) === null || _a === void 0 ? void 0 : _a.shippingAddress) === null || _b === void 0 ? void 0 : _b.countryCode,
                        paypalState: (_d = (_c = payload.details) === null || _c === void 0 ? void 0 : _c.shippingAddress) === null || _d === void 0 ? void 0 : _d.state,
                    });
                    if (!(payload.details.shippingAddress && payload.details.shippingAddress.countryCode === country)) return [3 /*break*/, 3];
                    pd = payload.details;
                    addr_1 = payload.details.shippingAddress;
                    fullState = config.states.find(function (s) { return s.abbreviation === addr_1.state; });
                    if (!(fullState && addr_1)) return [3 /*break*/, 2];
                    return [4 /*yield*/, setShippingAddress({
                            firstName: pd.firstName,
                            lastName: pd.lastName,
                            address1: addr_1.line1,
                            address2: addr_1.line2,
                            city: addr_1.city,
                            state: fullState.name,
                            zip: addr_1.postalCode,
                            phoneNumber: addr_1.phone || pd.phone || '8888606888',
                            country: config.countryName,
                        }, { email: email || payload.details.email })];
                case 1:
                    _e.sent();
                    setUsingPaypalExpressCheckout(true);
                    _e.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    setSubmitting(false);
                    _e.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var paypalEffect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var paypal;
        return __generator(this, function (_a) {
            paypal = window.paypal;
            if (!paypalCheckout || !paypal)
                return [2 /*return*/];
            if (isButtonRendered)
                return [2 /*return*/];
            paypal
                .Buttons({
                fundingSource: paypal.FUNDING.PAYPAL,
                createBillingAgreement: function () {
                    dataLayerPushEvent('checkout__paypalExpressCheckoutInitiated', {});
                    return paypalCheckout.createPayment({
                        flow: 'vault',
                        enableShippingAddress: true,
                    });
                },
                onApprove: function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    var payload;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!paypalCheckout || !window.paypal)
                                    return [2 /*return*/];
                                return [4 /*yield*/, paypalCheckout.tokenizePayment(data)];
                            case 1:
                                payload = _a.sent();
                                return [4 /*yield*/, handlePaypalData(payload)];
                            case 2:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); },
                style: {
                    height: 48,
                },
            })
                .render(containerRef.current);
            setButtonRendered(true);
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement("div", null, !!paypalCheckout && (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { id: paypalButtonContainerId, className: 'text-center', style: { height: '48px', maxWidth: '400px', margin: '0 auto' }, ref: containerRef })))));
});
